/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicCreateActivityMasterTemplate extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicCreateActivityMasterTemplate");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicCreateActivityMasterTemplate.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicCreateActivityMasterTemplate>): BackgroundJobPayloadForPeriodicCreateActivityMasterTemplate {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicCreateActivityMasterTemplate(), model);
        BackgroundJobPayloadForPeriodicCreateActivityMasterTemplate.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicCreateActivityMasterTemplate>): BackgroundJobPayloadForPeriodicCreateActivityMasterTemplate {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicCreateActivityMasterTemplate.newInstance(<BackgroundJobPayloadForPeriodicCreateActivityMasterTemplate> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicCreateActivityMasterTemplate) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicCreateActivityMasterTemplate.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicCreateActivityMasterTemplate): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicCreateActivityMasterTemplate.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
